import "./style.css";
import { Col, Row, FloatButton } from "antd";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { FullscreenOutlined } from "@ant-design/icons";
import { useRequiredAccess } from "../../../hooks/useRequiredAccess";
import { ORG_TYPES } from "../../Common/Constants";
import Metrics from "./Metrics";
import LastUpdatedStatus from "../../Common/LastUpdatedStatus";

const OperationalParameters = () => {
  const displayRef = useRef(null);
  const authToken = localStorage.getItem("authToken");
  const [timeFilter, setTimeFilter] = useState({});
  const pageLastUpdatedTime = useSelector((state) => state.loader)?.pageLastUpdatedTime;

  const openFullscreen = () => {
    const elem = displayRef.current;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };

  useEffect(() => {
    checkAccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken]);

  const checkAccess = useRequiredAccess(
    [],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
  );

  const onTimeChange = (key, value) => {
    setTimeFilter((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <>
      <FloatButton.Group shape="square" style={{ right: 15 }}>
        <FloatButton
          type="primary"
          onClick={openFullscreen}
          icon={<FullscreenOutlined style={{ fontSize: "24px" }} />}
          tooltip="Full Screen"
        />
      </FloatButton.Group>
      <div className="operational-parameter-page">
        <Row ref={displayRef}>
          <Col span={24}>
            <div className="title-card">
              <Row gutter={[16, 16]} justify={"space-between"}>
                <Col className="title-text pb2">Operational Parameters</Col>
                <Col className="updated-time-layout">
                  <LastUpdatedStatus 
                    showTime={'time-ago'}
                    lastUpdatedTime={pageLastUpdatedTime}
                  />                
                </Col>
              </Row>
            </div>

            <Row gutter={[16, 16]}>
              {[1, 2].map((data, index) => (
                <Col key={index} sm={24} md={12} lg={12}>
                  <div className="shadow-card mt1">
                    <Metrics
                      data={data}
                      timeFilter={timeFilter}
                      onTimeChange={onTimeChange}
                    />
                  </div>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default OperationalParameters;
